import { CspConfig } from "cy-remittance/auth/middleware";
import { remittanceConfig } from "@/config/remittance";

const { companyName, shortCompanyName, contactDetails } = remittanceConfig;

const csp: CspConfig = {
  scriptSrc: "https://*.techlab-cdn.com",
  // should we allow all dev / test / prod inclusions for oppwa.com or configure via vercel configurable settings
  frameSrc:
    "https://*.oppwa.com https://*.ozow.com https://*.transactionjunction.com",
  styleSrc: "https://*.oppwa.com/",
  imgSrc: "https://*.oppwa.com/",
  formAction: "https://*.oppwa.com/",
  workerSrc: "https://*.oppwa.com",
  // peach
  scriptSrcElem:
    "https://*.techlab-cdn.com https://*.peachpayments.com https://*.oppwa.com",
};

const imageAssets = {
  appleStartup: "/assets/images/icon.png",
  favicon: "/assets/images/favicon.png",
  appleTouchIcon512: "/assets/images/maskable_icon.png",
  openGraph: "/assets/images/og-image.png",
  loaderLogo: "/assets/images/tourvest-loader-logo.png",
  logo: {
    width: 289 * 0.8,
    height: 109 * 0.8,
    alt: companyName,
    src: "/assets/images/logo.png",
  },
};

export const registrationText = {
  createAccountHeader: `Create your ${companyName} account`,
  termsAgreementPrefix: `I agree to the ${companyName}`,
};

export const appConstants = {
  companyName,
  shortCompanyName,
  emailAddress: contactDetails.supportEmail,
  contactPhoneNumber: contactDetails.supportPhone,
  infoEmail: contactDetails.infoEmail ?? "",
  whatsappNumber: contactDetails.whatsappNumber ?? "",
  styling: {
    themeColor: "#fdaf33",
  },
  description:
    "Tourvest is Southern Africa's leading integrated tourism group, operating businesses which range from travel management companies, hotels, lodges and restaurants to craft, curio and jewellery shops and foreign exchange bureaux, under some 60 sector-leading brands, employing more than 8 000 people…",
  csp,
  images: {
    ...imageAssets,
  },
  externalLinks: {
    termsAndConditions: "https://www.tourvest.co.za/",
  },
};
